import { z } from 'zod';
import { SensorTypeSchema } from './SensorType';

export const MagicModelSchema = z.object({
  sensorType: SensorTypeSchema,
  sensorId: z.string(),
  modelName: z.string(),
});

export type MagicModel = z.infer<typeof MagicModelSchema>;
